var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout-gestao", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "form",
          {
            attrs: {
              autocomplete: "off",
              method: "post",
              "data-vv-scope": "form",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return (() => {}).apply(null, arguments)
              },
              submit: function ($event) {
                $event.preventDefault()
                return _vm.saveItem.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-sm-auto" }, [
                _c("h1", { staticClass: "content-title" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t" + _vm._s(_vm.titleItem) + "\n\t\t\t\t\t"
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-9" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|min:3",
                            expression: "'required|min:3'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          id: "input-name",
                          readonly: _vm.readonlyFormItem,
                          type: "text",
                          name: "name",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("name") },
                          ],
                          error: _vm.fnFirstError("name"),
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.name",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.name`)) +
                            "\n\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialSelect",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          id: "input-status",
                          disabled: _vm.readonlyFormItem,
                          name: "status",
                          label: "name",
                          filterable: true,
                          options: _vm.lists.onoff,
                          reduce: (option) => option.code,
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("status") },
                          ],
                          error: _vm.fnFirstError("status"),
                          helpText: _vm.help.status,
                        },
                        model: {
                          value: _vm.form.status,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "status",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.status",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.status`)) +
                            "\n\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          { name: "validate", rawName: "v-validate" },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          id: "input-page_title",
                          readonly: _vm.readonlyFormItem,
                          type: "text",
                          name: "page_title",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("page_title") },
                          ],
                          error: _vm.fnFirstError("page_title"),
                        },
                        model: {
                          value: _vm.form.page_title,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "page_title",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.page_title",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.page_title`)) +
                            "\n\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          { name: "validate", rawName: "v-validate" },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          id: "input-div_title",
                          readonly: _vm.readonlyFormItem,
                          type: "text",
                          name: "div_title",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("div_title") },
                          ],
                          error: _vm.fnFirstError("div_title"),
                          helpText: _vm.help.div_title,
                        },
                        model: {
                          value: _vm.form.div_title,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "div_title",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.div_title",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.page_title`)) +
                            "\n\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          { name: "validate", rawName: "v-validate" },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          id: "input-map_title",
                          readonly: _vm.readonlyFormItem,
                          type: "text",
                          name: "map_title",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("map_title") },
                          ],
                          error: _vm.fnFirstError("map_title"),
                        },
                        model: {
                          value: _vm.form.map_title,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "map_title",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.map_title",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.map_title`)) +
                            "\n\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialSelect",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "",
                            expression: "''",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          id: "input-module_scale_id",
                          disabled: _vm.readonlyFormItem,
                          name: "module_scale_id",
                          label: "scale",
                          multiple: false,
                          filterable: true,
                          options: _vm.lists.scales,
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("module_scale_id") },
                          ],
                          error: _vm.fnFirstError("module_scale_id"),
                        },
                        model: {
                          value: _vm.form.module_scale_id,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "module_scale_id",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.module_scale_id",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.scale`)) +
                            "\n\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|integer|min_value:1|max_value:600",
                            expression:
                              "'required|integer|min_value:1|max_value:600'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          id: "input-dpi",
                          readonly: _vm.readonlyFormItem,
                          type: "number",
                          name: "dpi",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("dpi") },
                          ],
                          error: _vm.fnFirstError("dpi"),
                        },
                        model: {
                          value: _vm.form.dpi,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "dpi",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.dpi",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.dpi`)) +
                            "\n\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          { name: "uppercase", rawName: "v-uppercase" },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, regex: /^EPSG:\d+$/i },
                            expression:
                              "{ required: true, regex: /^EPSG:\\d+$/i }",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          id: "input-crs",
                          readonly: _vm.readonlyFormItem,
                          type: "text",
                          name: "crs",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("crs") },
                          ],
                          error: _vm.fnFirstError("crs"),
                        },
                        model: {
                          value: _vm.form.crs,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "crs",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.crs",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.crs`)) +
                            "\n\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group city-form-group city-bg mb-0" },
                  [
                    _c(
                      "MaterialTextarea",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "min:3",
                            expression: "'min:3'",
                          },
                        ],
                        staticClass: "city-form-group city-bg mb-0",
                        attrs: {
                          id: "input-comment",
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          name: "comment",
                          rows: 4,
                          helpText: _vm.help.comment,
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("comment") },
                          ],
                          error: _vm.fnFirstError("comment"),
                        },
                        model: {
                          value: _vm.form.comment,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "comment",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.comment",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.comment`)) +
                            "\n\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("h4", { staticClass: "mt-4" }, [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.$t(`${_vm.pageID}.form.layers`)) +
                    "\n\t\t\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                !_vm.readonlyFormItem
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "order-2 order-sm-1 col-12 col-sm-7 col-lg-6",
                      },
                      [
                        _c("table-data", {
                          ref: "tblResources",
                          attrs: {
                            showTitleData: false,
                            tableWrapperClass: "py-2 px-1",
                            startLoad: _vm.startLoadResources,
                            route: _vm.url.getResources,
                            settings: _vm.table.settings,
                            columns: _vm.table.columns,
                            inlineFilters: _vm.table.filters,
                            autoUpdateFilter: _vm.table.autoUpdateFilter,
                            externalFilters: _vm.tblFilters,
                            autoUpdateExternalFilter:
                              _vm.table.autoUpdateExternalFilter,
                            addParamsToUrl: _vm.table.addParamsToUrl,
                            loadingMsg: _vm.table.loadingMsg,
                            notFoundMsg: _vm.table.notFoundMsg,
                            orderByTemplate: _vm.table.orderByTemplate,
                          },
                          on: { "error-load": _vm.showError },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "filters",
                                fn: function ({ tableFilters, search }) {
                                  return [
                                    _c(
                                      "form",
                                      {
                                        attrs: { autocomplete: "false" },
                                        on: {
                                          submit: function ($event) {
                                            $event.preventDefault()
                                            return search.apply(null, arguments)
                                          },
                                          keyup: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            return search.apply(null, arguments)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "row header" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-12" },
                                              [
                                                _c("header-list", {
                                                  attrs: {
                                                    title: null,
                                                    placeholderSearch:
                                                      _vm.searchPlaceholder,
                                                    headerClass: "mb-3",
                                                  },
                                                  model: {
                                                    value: tableFilters.q,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        tableFilters,
                                                        "q",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "tableFilters.q",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "body",
                                fn: function ({ row, index, remove }) {
                                  return [
                                    _c(
                                      "td",
                                      { class: _vm.table.columns[0].class },
                                      [
                                        _c("ResourceItemList", {
                                          attrs: {
                                            value: row,
                                            enableCrossResource:
                                              _vm.enableCrossresources,
                                            readonlyForm: _vm.readonlyFormItem,
                                          },
                                          on: {
                                            addResource: function ($event) {
                                              return _vm.addResource(
                                                row,
                                                index,
                                                remove
                                              )
                                            },
                                            addCrossResource: function (
                                              $event
                                            ) {
                                              return _vm.addCrossResource(
                                                row,
                                                index
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1293587968
                          ),
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "order-1 order-sm-2 col-12 col-sm-5 col-lg-6",
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "h5",
                            {
                              staticClass:
                                "d-flex justify-content-between justify-content-md-start align-items-center mb-3",
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "text-muted pr-md-4" },
                                [_vm._v(_vm._s(_vm.help.resources_title))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-secondary badge-pill",
                                },
                                [_vm._v(_vm._s(_vm.form.resources.length))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group city-form-group" },
                            [
                              _vm.fnHasError("resources")
                                ? _c(
                                    "small",
                                    { staticClass: "invalid-feedback d-block" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.fnFirstError("resources"))
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "draggable",
                            _vm._b(
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: _vm.form.plan_id },
                                    expression: "{required: form.plan_id}",
                                  },
                                ],
                                attrs: {
                                  tag: "div",
                                  draggable: ".list-group-item",
                                  name: "resources",
                                },
                                on: {
                                  start: _vm.onDragStart,
                                  end: _vm.onDragEnd,
                                },
                                model: {
                                  value: _vm.form.resources,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "resources", $$v)
                                  },
                                  expression: "form.resources",
                                },
                              },
                              "draggable",
                              _vm.dragOptions,
                              false
                            ),
                            [
                              _c(
                                "transition-group",
                                {
                                  directives: [
                                    { name: "validate", rawName: "v-validate" },
                                  ],
                                  staticClass: "p-0",
                                  attrs: {
                                    tag: "ul",
                                    type: "transition",
                                    name: !_vm.drag ? "flip-list" : null,
                                  },
                                },
                                _vm._l(
                                  _vm.form.resources,
                                  function (element, idx) {
                                    return _c(
                                      "li",
                                      {
                                        key: element.id,
                                        staticClass:
                                          "list-group-item p-0 border-0",
                                        class: {
                                          "cursor-move": !_vm.readonlyFormItem,
                                        },
                                      },
                                      [
                                        _c("ResourceItemSelected", {
                                          attrs: {
                                            value: element,
                                            readonlyForm: _vm.readonlyFormItem,
                                            pivotKey: _vm.pivotResources,
                                          },
                                          on: {
                                            removeResource: function ($event) {
                                              return _vm.removeResource(idx)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.enableCrossresources
                      ? _c("div", { staticClass: "row mt-4" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "d-flex justify-content-between justify-content-md-start align-items-center mb-3",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "text-muted pr-md-4" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.help.crossresources_title)
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-secondary badge-pill",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.form.crossresources.length)
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-group city-form-group" },
                                [
                                  _vm.fnHasError("crossresources")
                                    ? _c(
                                        "small",
                                        {
                                          staticClass:
                                            "invalid-feedback d-block",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.fnFirstError("crossresources")
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "draggable",
                                _vm._b(
                                  {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: { required: false },
                                        expression: "{required: false}",
                                      },
                                    ],
                                    attrs: {
                                      tag: "div",
                                      draggable: ".list-group-item",
                                      name: "crossresources",
                                    },
                                    on: {
                                      start: _vm.onDragStartCrossResources,
                                      end: _vm.onDragEndCrossResources,
                                    },
                                    model: {
                                      value: _vm.form.crossresources,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "crossresources",
                                          $$v
                                        )
                                      },
                                      expression: "form.crossresources",
                                    },
                                  },
                                  "draggable",
                                  _vm.dragOptions,
                                  false
                                ),
                                [
                                  _c(
                                    "transition-group",
                                    {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                        },
                                      ],
                                      staticClass: "p-0",
                                      attrs: {
                                        tag: "ul",
                                        type: "transition",
                                        name: !_vm.dragCrossResources
                                          ? "flip-list"
                                          : null,
                                      },
                                    },
                                    _vm._l(
                                      _vm.form.crossresources,
                                      function (element, idx) {
                                        return _c(
                                          "li",
                                          {
                                            key: `crossresources-${element.id}`,
                                            staticClass:
                                              "list-group-item p-0 border-0",
                                            class: {
                                              "cursor-move":
                                                !_vm.readonlyFormItem,
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "card flex-md-row",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "card-body d-flex flex-column align-items-start py-2 px-3",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex flex-column w-100",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex flex-row align-items-center justify-content-start mb-3 w-100",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex flex-column justify-content-between mr-3",
                                                              },
                                                              [
                                                                element.service
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "badge",
                                                                        class:
                                                                          _vm.getClassServiceCode(
                                                                            element.service
                                                                          ),
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                            _vm._s(
                                                                              _vm.getServiceCode(
                                                                                element.service
                                                                              )
                                                                            ) +
                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "w-100",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "d-flex flex-row align-items-center justify-content-between w-100 mb-1",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "d-inline-block text-primary",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            element.name
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    !_vm.readonlyFormItem
                                                                      ? _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "cursor-pointer fa fa-times close",
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  $event.preventDefault()
                                                                                  return _vm.removeCrossResource(
                                                                                    idx
                                                                                  )
                                                                                },
                                                                            },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "h6",
                                                                  {
                                                                    staticClass:
                                                                      "mb-0",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                        _vm._s(
                                                                          element.title
                                                                            ? element.title
                                                                            : element.name
                                                                        ) +
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        element.featuretype &&
                                                        element.featuretype
                                                          .properties.length
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex flex-column justify-content-between",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "row",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "col",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "form-group",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "MaterialSelect",
                                                                              {
                                                                                directives:
                                                                                  [
                                                                                    {
                                                                                      name: "validate",
                                                                                      rawName:
                                                                                        "v-validate",
                                                                                      value:
                                                                                        "required",
                                                                                      expression:
                                                                                        "'required'",
                                                                                    },
                                                                                  ],
                                                                                staticClass:
                                                                                  "city-form-group city-bg",
                                                                                attrs:
                                                                                  {
                                                                                    id: `input-crossresources-name-${element.id}`,
                                                                                    disabled:
                                                                                      _vm.readonlyFormItem,
                                                                                    name: `crossresources-name-${element.id}`,
                                                                                    options:
                                                                                      element
                                                                                        .featuretype
                                                                                        .properties,
                                                                                    label:
                                                                                      "name",
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      element[
                                                                                        _vm
                                                                                          .pivotCrossResources
                                                                                      ]
                                                                                        .name_feature_type_property_id,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          element[
                                                                                            _vm
                                                                                              .pivotCrossResources
                                                                                          ],
                                                                                          "name_feature_type_property_id",
                                                                                          typeof $$v ===
                                                                                            "string"
                                                                                            ? $$v.trim()
                                                                                            : $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "element[pivotCrossResources].name_feature_type_property_id",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                    _vm._s(
                                                                                      _vm.$t(
                                                                                        `${_vm.pageID}.form.field_name`
                                                                                      )
                                                                                    ) +
                                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "row",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "col",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "form-group",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "MaterialSelect",
                                                                              {
                                                                                directives:
                                                                                  [
                                                                                    {
                                                                                      name: "validate",
                                                                                      rawName:
                                                                                        "v-validate",
                                                                                      value:
                                                                                        "",
                                                                                      expression:
                                                                                        "''",
                                                                                    },
                                                                                  ],
                                                                                staticClass:
                                                                                  "city-form-group city-bg",
                                                                                attrs:
                                                                                  {
                                                                                    id: `input-crossresources-descr-${element.id}`,
                                                                                    disabled:
                                                                                      _vm.readonlyFormItem,
                                                                                    name: `crossresources-descr-${element.id}`,
                                                                                    options:
                                                                                      element
                                                                                        .featuretype
                                                                                        .properties,
                                                                                    label:
                                                                                      "name",
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      element[
                                                                                        _vm
                                                                                          .pivotCrossResources
                                                                                      ]
                                                                                        .descr_feature_type_property_id,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          element[
                                                                                            _vm
                                                                                              .pivotCrossResources
                                                                                          ],
                                                                                          "descr_feature_type_property_id",
                                                                                          typeof $$v ===
                                                                                            "string"
                                                                                            ? $$v.trim()
                                                                                            : $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "element[pivotCrossResources].descr_feature_type_property_id",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                    _vm._s(
                                                                                      _vm.$t(
                                                                                        `${_vm.pageID}.form.field_descr`
                                                                                      )
                                                                                    ) +
                                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("buttons-footer", {
              attrs: {
                enableButtons: !_vm.readonlyFormItem,
                cancelTitle: _vm.cancelTitle,
                submitTitle: _vm.submitTitle,
                isDisabled: _vm.isDisabled,
              },
              on: {
                save: _vm.saveItem,
                cancel: function ($event) {
                  return _vm.handleBack(
                    `${_vm.moduleInternalCode}.${_vm.pageID}`
                  )
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }